
import React from 'react';

/**
 * Enhanced background effects for the hero section
 * Creates atmospheric gradient overlays that complement the data wave visualization
 */
const BackgroundEffects = () => {
  return (
    <>
      {/* Base background and gradients */}
      <div className="absolute inset-0 bg-[#0f172a]"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f172a]/95 via-[#0f172a]/90 to-[#0f172a]/95"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/60 to-transparent"></div>
      <div className="absolute inset-0 bg-radial-gradient from-blue-900/5 to-transparent"></div>
      
      {/* Atmospheric glow points */}
      <div className="absolute top-1/4 right-1/3 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/3 left-1/4 w-96 h-96 bg-indigo-600/5 rounded-full blur-3xl"></div>
      
      {/* Text legibility gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0f172a]/30"></div>
    </>
  );
};

export default BackgroundEffects;
